import { CONFIG } from '../../Config/config'
import store from 'Config/store'

import { localStore } from '../../Module/Browser/LocalStorage'
import { isClientRole, isManagerRole } from '../../Utils/Validators/roles'

import {
  setAPIKey as setWsAPIKey,
  clearAPIKey as clearWsAPIKey,
  release as releaseWs,
} from '../../shared/websockets'

class Authorization {
  /**
   * Browser storage
   */
  storage

  /**
   *
   * @param storage
   */
  constructor(storage) {
    this.storage = storage
  }

  /**
   * Login user to app
   * @param user
   * @param apiKey
   */
  login({ user, apiKey, countryName, countryCode }) {
    this.storage.setData(CONFIG.STORE.USER_KEY, {
      ...user,
      countryName: countryName,
      countryCode: countryCode,
    })
    this.storage.setData(CONFIG.STORE.API_KEY, apiKey)

    setWsAPIKey(apiKey)
  }

  /**
   * Logout user from app
   */
  logout() {
    try {
      this.storage.removeData(CONFIG.STORE.USER_KEY)
      this.storage.removeData(CONFIG.STORE.API_KEY)
      if (store.getState().websockets.connected) {
        clearWsAPIKey()
        releaseWs()
      }
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * Is user logged
   * @returns boolean
   */
  isLogged() {
    const user = this.getUser()
    const apiKey = this.getAPIKey()
    return user && apiKey
  }

  /**
   * User is admin
   * @returns boolean
   */
  isAdmin() {
    const user = this.getUser()
    return this.isLogged() && user.role === CONFIG.USER_ROLE.ADMIN
  }

  /**
   * User is city manager
   * @returns boolean
   */
  isCityManager() {
    const user = this.getUser()
    return this.isLogged() && isManagerRole(user.role)
  }

  /**
   * User is client
   * @param role string In case that need to check before save the user role
   * @returns boolean
   */
  isClient() {
    const user = this.getUser()
    return this.isLogged() && isClientRole(user.role)
  }

  /**
   * User is client admin
   * @param role string In case that need to check before save the user role
   * @returns boolean
   */
  isClientAdmin() {
    const user = this.getUser()
    return this.isLogged() && user.role === CONFIG.USER_ROLE.CLIENT_ADMIN
  }

  /**
   * User is client role
   * @returns boolean
   */
  isClientRole() {
    return this.isClientAdmin() || this.isClient()
  }

  /**
   * User is recruiter
   * @param role string In case that need to check before save the user role
   * @returns boolean
   */
  isRecruiter() {
    const user = this.getUser()
    return this.isLogged() && user.role === CONFIG.USER_ROLE.RECRUITER
  }

  /**
   * User is spy
   * @param role string In case that need to check before save the user role
   * @returns boolean
   */
  isSpy() {
    const user = this.getUser()
    return this.isLogged() && user.role === CONFIG.USER_ROLE.SPY
  }
  /**
   * Get user
   */
  getUser() {
    return this.storage.getData(CONFIG.STORE.USER_KEY)
  }

  /**
   * Update user
   */
  updateUser(user) {
    this.storage.setData(CONFIG.STORE.USER_KEY, user)
  }

  /**
   * Get API key
   */
  getAPIKey() {
    return this.storage.getData(CONFIG.STORE.API_KEY)
  }
}

export const authorization = new Authorization(localStore)



// WEBPACK FOOTER //
// ./src/Module/Auth/Auth.js